import axios from 'axios';
import { getUrlBaseValue } from '../common/utils';

export const getDataFromAPI = async (
  urlAPI,
  headersAPI,
  methodAPI,
  dataObject = null,
) => {
  let axiosCallRes = '';
  const getAuthTooken = localStorage.getItem('authToken');
  const headersAPIConst = {
    'Content-type': 'application/json; charset=UTF-8',
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_PHARMACY_SUBS_KEY,
    Authorization: getAuthTooken,
  };

  const updatedHeader = headersAPI !== null ? headersAPI : headersAPIConst;
  try {
    axiosCallRes = await axios({
      url: `${getUrlBaseValue()}${urlAPI}`,
      method: methodAPI,
      headers: updatedHeader,
      data: dataObject,
    });
    return axiosCallRes;
  } catch (error) {
    return error;
  }
};
